class BottleColorPickerController {
  constructor(orchestrator) {
    this.orchestrator = orchestrator;
  }

  handleColorButtonClick(button) {
    const {
      COLORS,
      selectionState,
      artsPanelController,
      finishCheckoutController,
      bottleSceneController,
    } = this.orchestrator;
    const { colorButtons } = this.orchestrator.dom;

    if (button.disabled) return;

    const colorKey = button.dataset.color;
    if (!COLORS[colorKey]) return;

    selectionState.selectedColorKey = colorKey;
    colorButtons.forEach(item => item.classList.remove('active'));
    button.classList.add('active');
    finishCheckoutController.syncFinishProductColor();

    const clearedArt = artsPanelController.clearSelectedArtIfDisallowed();
    artsPanelController.renderArtsGrid();

    if (!clearedArt && bottleSceneController.bodyMaterial) {
      bottleSceneController.applySelection();
    }
  }

  initialize() {
    const { customizerMain, colorButtons } = this.orchestrator.dom;
    if (customizerMain.dataset.colorsReady === 'true') return;
    customizerMain.dataset.colorsReady = 'true';

    colorButtons.forEach(button => {
      button.addEventListener('click', () => {
        this.handleColorButtonClick(button);
      });
    });
  }
}

window.BottleColorPickerController = BottleColorPickerController;
